import React from 'react';
import ReactDOM from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.min.css';

// ⚠️ Bootstrap ka JS - iske bina dropdown, modal, collapse kuch
// bhi kaam nahi karta.
//
// Pehle sirf CSS import thi, isliye "My Account" ka dropdown
// DIKHTA tha par KHULTA nahi tha - data-bs-toggle="dropdown"
// ko JS chahiye hota hai.
//
// bundle wala isliye ki usme Popper.js bhi hai, jo dropdown ki
// positioning karta hai. Bina Popper ke dropdown galat jagah
// khulta hai (kabhi screen se bahar).
import 'bootstrap/dist/js/bootstrap.bundle.min';

import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './mobile.css';

import App from './App';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(
    document.getElementById('root'));

root.render(
    <AuthProvider>
        <App />
    </AuthProvider>
);

// ⚠️ Service worker ab DEV MEIN BHI register hota hai.
//
// Pehle sirf production mein hota tha (NODE_ENV check), kyunki
// dev mein wo purana code cache kar leta tha. Par push
// notifications isi pe nirbhar hain - SW ke bina
// navigator.serviceWorker.ready kabhi resolve nahi hota aur
// "Enable notifications" button hamesha ke liye atak jaata hai.
// Matlab push local pe test hi nahi ho sakta tha.
//
// ⚠️ Iska nuksaan: dev mein kabhi-kabhi purana code chalega. Wo
// dikhe to F12 > Application > Service Workers > Unregister
// karke refresh karna. sw.js mein localhost pe fetch intercept
// band kar diya hai, isliye ab ye kam hota hai.
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js')
            .then(reg => console.log('SW registered', reg.scope))
            .catch(err => console.log('SW failed', err));
    });
}